import { IGetAllExecutadoPorUseCase } from "../../../presentation/useCases/read/get_all_executado_por_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ExecutadoPor } from "../../models/executador_por";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllExecutadoPorUseCase
 */

export class GetAllExecutadoPorUseCase extends BasePaginatedUseCase<ExecutadoPor> implements IGetAllExecutadoPorUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllExecutadoPor(
    idInspecaoObra: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idInspecaoObra === undefined) throw new Error('Id de inspeção obra invalido!');

    const response = await this.repository.getAllExecutadoPor(
      idInspecaoObra,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
